import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BsArrowRightShort } from "react-icons/bs";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
import { useSelector } from "react-redux";
import performRequest from "../../../api/request";
import getFilteredURL from "../../../Components/Functions/filters.getUrl";
import { Toast } from "../../../CustomComponent/toast";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";

const tableHead = [
  "Sr.",
  "Plant",
  "Plant Name",
  "Wholesale Price Low",
  "Wholesale Price High",
  "Retail Price Low",
  "Retail Price High",
  "Actions",
];

const PriceWatcherTable = ({
  data = [],
  agro = [],
  currentPage,
  itemsPerPage,
}) => {
  const navigate = useNavigate();

  const store = useSelector((store) => store.login.user);
  const [checkClientAccess, setCheckClientAccess] = useState({
    workOrder: false,
    isHandOverCompleted: false,
    isClient: store?.Role == process.env.REACT_APP_ROLE_CLIENT,
  });
  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL("/projectTracking/getProjectTracking", 1)
    )
      .then((res) => {
        if (res.status === 200) {
          let access = {
            isHandOverCompleted: false,
            workOrder: false,
            isClient: false,
          };

          if (res?.data?.clientHandover?.handOverCertificate) {
            access.isHandOverCompleted = true;
          }
          if (res?.data?.projectTrackingData?.[0]?.workOrderUpload) {
            access.workOrder = true;
          }
          if (store?.Role == process.env.REACT_APP_ROLE_CLIENT) {
            access.isClient = true;
          }
          setCheckClientAccess(access);
        } else {
          Toast("error", "Error while getting Leads!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  function calculateDiscountedPrice(originalPrice, discount) {
    const discountedPrice = originalPrice * (1 - discount);
    return discountedPrice;
  }
  const goToView = (id) => {
    if (
      checkClientAccess?.isClient &&
      !checkClientAccess?.isHandOverCompleted
    ) {
      Toast(
        "error",
        "Your handover process has not been completed yet, so this page is currently unavailable. Please contact the Kryzen support team for further assistance."
      );
    } else {
      navigate(`/buyers-price-watcher/view/${id}`);
    }
  };

  const getImageUrl = (plantId) => {
    const agroItem = agro.find((item) => item.id === plantId);
    return agroItem ? agroItem.image : null;
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead.map((item, index) => (
              <th key={index}>{item}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>
                  {getImageUrl(item?.plantId) ? (
                    <img
                      src={getImageUrl(item?.plantId)}
                      alt="Plant"
                      width="30"
                    />
                  ) : (
                    "N/A"
                  )}
                </td>
                <td>{item?.plantName || "N/A"}</td>
                <td>
                  ₹
                  {calculateDiscountedPrice(item?.weeklyPrice, 0.35)?.toFixed(
                    2
                  ) || "N/A"}
                </td>
                <td>
                  ₹
                  {calculateDiscountedPrice(item?.weeklyPrice, 0.15)?.toFixed(
                    2
                  ) || "N/A"}
                </td>
                <td>
                  ₹
                  {calculateDiscountedPrice(item?.weeklyPrice, 0.05)?.toFixed(
                    2
                  ) || "N/A"}
                </td>
                <td>₹{item?.weeklyPrice || "N/A"}</td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item?.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default PriceWatcherTable;
